<template>
  <div class="dashboard-container">

    <el-card class="admin-tip">
      {{ $t('dashboard.now_time', {
        nickname: nickname,
        nowTimeCall: nowTimeCall,
        nowTime: nowTime
      }) }}
    </el-card>

    <panel-group />

    <el-row v-if="showEntryStats" :gutter="24" class="entry-stats-row">
      <el-col :xs="24" :sm="24" :lg="12">
        <el-card class="chart-wrapper entry-stats-card">
          <div slot="header" class="clearfix">
            <span>业务类型当月录入数量</span>
          </div>
          <el-table
            v-loading="entryStatsLoading"
            :data="entryStatsTableWithTotal"
            border
            style="width: 100%"
            :row-class-name="entryStatsRowClassName"
          >
            <el-table-column prop="name" label="姓名" min-width="80" />
            <el-table-column
              v-for="col in entryStatsTypeColumns"
              :key="col"
              :prop="col"
              :label="typeColumnLabel(col)"
              min-width="80"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row[col] !== undefined && scope.row[col] !== '' ? scope.row[col] : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="rowTotal" label="合计" min-width="80" align="right">
              <template slot-scope="scope">
                {{ scope.row.rowTotal !== undefined && scope.row.rowTotal !== '' ? scope.row.rowTotal : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="deposit_count" label="报名" min-width="80" align="right">
              <template slot-scope="scope">
                {{ scope.row.deposit_count !== undefined && scope.row.deposit_count !== '' ? scope.row.deposit_count : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="order_amount" label="收款" min-width="90" align="right">
              <template slot-scope="scope">
                {{ scope.row.order_amount !== undefined && scope.row.order_amount !== '' ? scope.row.order_amount : '0' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <el-card class="chart-wrapper entry-stats-channel-card">
          <div slot="header" class="clearfix">
            <span>按渠道统计</span>
          </div>
          <el-table
            v-loading="entryStatsLoading"
            :data="entryStatsTableWithTotal"
            border
            style="width: 100%"
            :row-class-name="entryStatsRowClassName"
          >
            <el-table-column prop="name" label="姓名" min-width="80" />
            <el-table-column
              v-for="col in entryStatsChannelColumns"
              :key="col"
              :prop="col"
              :label="col"
              min-width="90"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row[col] !== undefined && scope.row[col] !== '' ? scope.row[col] : '0' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-if="showEntryStats" :gutter="24" class="entry-stats-row">
      <el-col :xs="24" :sm="24" :lg="12">
        <el-card class="chart-wrapper entry-stats-card">
          <div slot="header" class="clearfix">
            <span>业务类型当月录入数量（按渠道）</span>
          </div>
          <el-table
            v-loading="entryStatsLoading"
            :data="entryStatsSourceTableWithTotal"
            border
            style="width: 100%"
            :row-class-name="entryStatsRowClassName"
          >
            <el-table-column prop="name" label="姓名" min-width="80" />
            <el-table-column
              v-for="col in entryStatsTypeColumns"
              :key="'src-' + col"
              :prop="col"
              :label="typeColumnLabel(col)"
              min-width="80"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row[col] !== undefined && scope.row[col] !== '' ? scope.row[col] : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="rowTotal" label="合计" min-width="80" align="right">
              <template slot-scope="scope">
                {{ scope.row.rowTotal !== undefined && scope.row.rowTotal !== '' ? scope.row.rowTotal : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="deposit_count" label="报名" min-width="80" align="right">
              <template slot-scope="scope">
                {{ scope.row.deposit_count !== undefined && scope.row.deposit_count !== '' ? scope.row.deposit_count : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="order_amount" label="收款" min-width="90" align="right">
              <template slot-scope="scope">
                {{ scope.row.order_amount !== undefined && scope.row.order_amount !== '' ? scope.row.order_amount : '0' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <!--
        <el-card class="chart-wrapper entry-stats-channel-card">
          <div slot="header" class="clearfix">
            <span>按渠道统计（按渠道）</span>
          </div>
          <el-table
            v-loading="entryStatsLoading"
            :data="entryStatsSourceTableWithTotal"
            border
            style="width: 100%"
            :row-class-name="entryStatsRowClassName"
          >
            <el-table-column prop="name" label="姓名" min-width="80" />
            <el-table-column
              v-for="col in entryStatsChannelColumns"
              :key="'src-ch-' + col"
              :prop="col"
              :label="col"
              min-width="90"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row[col] !== undefined && scope.row[col] !== '' ? scope.row[col] : '0' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        -->
        <el-card class="chart-wrapper entry-stats-card">
          <div slot="header" class="clearfix">
            <span>业务类型上月录入数量</span>
          </div>
          <el-table
            v-loading="entryStatsLastMonthLoading"
            :data="entryStatsLastMonthTableWithTotal"
            border
            style="width: 100%"
            :row-class-name="entryStatsRowClassName"
          >
            <el-table-column prop="name" label="姓名" min-width="80" />
            <el-table-column
              v-for="col in entryStatsLastMonthTypeColumns"
              :key="'last-' + col"
              :prop="col"
              :label="typeColumnLabel(col)"
              min-width="80"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row[col] !== undefined && scope.row[col] !== '' ? scope.row[col] : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="rowTotal" label="合计" min-width="80" align="right">
              <template slot-scope="scope">
                {{ scope.row.rowTotal !== undefined && scope.row.rowTotal !== '' ? scope.row.rowTotal : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="deposit_count" label="报名" min-width="80" align="right">
              <template slot-scope="scope">
                {{ scope.row.deposit_count !== undefined && scope.row.deposit_count !== '' ? scope.row.deposit_count : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="order_amount" label="收款" min-width="90" align="right">
              <template slot-scope="scope">
                {{ scope.row.order_amount !== undefined && scope.row.order_amount !== '' ? scope.row.order_amount : '0' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="chart-wrapper">
          <raddar-chart />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="chart-wrapper">
          <pie-chart />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="chart-wrapper">
          <bar-chart />
        </div>
      </el-col>
    </el-row>

    <component :is="currentSystem" />
  </div>
</template>

<script>
import checkPermission from '@/utils/permission'
import PanelGroup from './components/PanelGroup'
import SystemTable from './components/SystemTable'
import RaddarChart from './components/RaddarChart'
import PieChart from './components/PieChart'
import BarChart from './components/BarChart'
import { getEntryStatsByMonth, getEntryStatsByLastMonthPeriod } from '@/api/student'

export default {
  name: 'DashboardAdmin',
  components: {
    PanelGroup,
    SystemTable,
    RaddarChart,
    PieChart,
    BarChart
  },
  data() {
    return {
      nickname: '',

      nowTime: '',
      nowTimeCall: this.$t('dashboard.night'),

      timer: '',

      currentSystem: 'SystemTable',

      showEntryStats: false,
      entryStatsLoading: false,
      entryStatsTableData: [],
      entryStatsSourceTableData: [],
      entryStatsTypeColumns: [],
      entryStatsLastMonthLoading: false,
      entryStatsLastMonthTableData: [],
      entryStatsLastMonthTypeColumns: [],
      // 渠道表列：姓名 + 小红书/抖音/其他 及其报名、收款
      entryStatsChannelColumns: [
        '小红书', '小红书报名', '小红书收款',
        '抖音', '抖音报名', '抖音收款',
        '其他', '其他报名', '其他收款'
      ]
    }
  },
  computed: {
    entryStatsTableWithTotal() {
      return this.buildEntryStatsTableWithTotal(this.entryStatsTableData, this.entryStatsTypeColumns)
    },
    entryStatsSourceTableWithTotal() {
      return this.buildEntryStatsTableWithTotal(this.entryStatsSourceTableData, this.entryStatsTypeColumns)
    },
    entryStatsLastMonthTableWithTotal() {
      return this.buildEntryStatsTableWithTotal(this.entryStatsLastMonthTableData, this.entryStatsLastMonthTypeColumns)
    }
  },
  created() {
    const thiz = this

    this.nickname = this.$store.getters.nickname
    if (!this.nickname) {
      setTimeout(function() {
        thiz.getNickname()
      }, 5000)
    }

    this.timer = setInterval(this.setNowTime, 1000)

    if (!checkPermission(['larke-admin.system.info'])) {
      this.currentSystem = ''
    }

    if (checkPermission(['larke-admin.ext.student.index'])) {
      this.showEntryStats = true
      this.fetchEntryStatsByMonth()
      this.fetchEntryStatsByLastMonthPeriod()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    dateFilter(date) {
      if (date < 10) {
        return '0' + date
      }
      return date
    },
    getNowTime() {
      var dateObj = new Date()
      var year = dateObj.getFullYear()
      var month = dateObj.getMonth() + 1
      var date = dateObj.getDate()
      var day = dateObj.getDay()
      var weeks = [
        this.$t('dashboard.sunday'),
        this.$t('dashboard.monday'),
        this.$t('dashboard.tuesday'),
        this.$t('dashboard.wednesday'),
        this.$t('dashboard.thursdday'),
        this.$t('dashboard.friday'),
        this.$t('dashboard.saturday')
      ]
      var week = weeks[day]
      var hour = dateObj.getHours()
      var minute = dateObj.getMinutes()
      var second = dateObj.getSeconds()
      var timeValue = '' + (
        (hour >= 12)
          ? ((hour >= 18) ? this.$t('dashboard.night') : this.$t('dashboard.afternoon'))
          : ((hour >= 8) ? this.$t('dashboard.morning') : this.$t('dashboard.midnight'))
      )
      var nowTime = this.$t('dashboard.now_time_show', {
        year: this.dateFilter(year),
        month: this.dateFilter(month),
        day: this.dateFilter(date),
        hour: this.dateFilter(hour),
        minute: this.dateFilter(minute),
        second: this.dateFilter(second),
        week: week
      })
      return [nowTime, timeValue]
    },
    setNowTime() {
      const nowTime = this.getNowTime()
      this.nowTime = nowTime[0]
      this.nowTimeCall = nowTime[1]
    },
    getNickname() {
      this.nickname = this.$store.getters.nickname
    },
    typeColumnLabel(typeKey) {
      return typeKey
    },
    entryStatsRowClassName({ row }) {
      return row && row.isTotal ? 'entry-stats-total-row' : ''
    },
    buildEntryStatsTableWithTotal(rows, cols) {
      const channelCols = this.entryStatsChannelColumns
      if (!rows.length) return []
      const withRowTotal = rows.map(row => {
        const rowTotal = cols.length ? cols.reduce((s, t) => s + (Number(row[t]) || 0), 0) : 0
        return { ...row, rowTotal }
      })
      const totalRow = { name: '合计', isTotal: true }
      cols.forEach(t => {
        totalRow[t] = rows.reduce((s, r) => s + (Number(r[t]) || 0), 0)
      })
      totalRow.rowTotal = cols.reduce((s, t) => s + (Number(totalRow[t]) || 0), 0)
      totalRow.deposit_count = rows.reduce((s, r) => s + (Number(r.deposit_count) || 0), 0)
      totalRow.order_amount = rows.reduce((s, r) => s + (Number(r.order_amount) || 0), 0)
      channelCols.forEach(c => {
        totalRow[c] = rows.reduce((s, r) => s + (Number(r[c]) || 0), 0)
      })
      return withRowTotal.concat([totalRow])
    },
    resolveEntryStatsData(data) {
      if (typeof data !== 'object' || data === null) {
        return {
          byPerson: {},
          bySource: {},
          typeColumns: []
        }
      }
      const byPerson = data.byPerson != null ? data.byPerson : data
      const bySource = data.bySource || {}
      const typeOrder = [
        '国硕代理项目', '美国硕博', '新业务硕博', '硕博在线项目', '才大硕博',
        '北京硕博', '国际硕博', '研之堂硕博', '网络硕博', '博士项目', '重庆硕博'
      ]
      const extraKeys = [
        'deposit_count', 'order_amount',
        '小红书', '小红书报名', '小红书收款',
        '抖音', '抖音报名', '抖音收款',
        '其他', '其他报名', '其他收款'
      ]
      const allTypes = new Set()
      Object.values(byPerson).forEach(typeCounts => {
        (Object.keys(typeCounts || {}) || []).forEach(t => {
          if (!extraKeys.includes(t)) allTypes.add(t)
        })
      })
      Object.values(bySource).forEach(typeCounts => {
        (Object.keys(typeCounts || {}) || []).forEach(t => {
          if (!extraKeys.includes(t)) allTypes.add(t)
        })
      })
      const typeColumns = typeOrder.filter(t => allTypes.has(t)).concat(
        [...allTypes].filter(t => !typeOrder.includes(t)).sort()
      )
      return { byPerson, bySource, typeColumns }
    },
    buildEntryStatsRows(dataMap, typeColumns) {
      const buildRow = (name, typeCounts) => {
        const row = { name }
        typeColumns.forEach(t => {
          row[t] = (typeCounts && typeCounts[t]) || 0
        })
        row.deposit_count = Number(typeCounts && typeCounts.deposit_count) || 0
        row.order_amount = Number(typeCounts && typeCounts.order_amount) || 0
        this.entryStatsChannelColumns.forEach(c => {
          row[c] = (typeCounts && typeCounts[c] !== undefined && typeCounts[c] !== null && typeCounts[c] !== '') ? typeCounts[c] : 0
        })
        return row
      }
      return Object.entries(dataMap || {}).map(([name, typeCounts]) => buildRow(name, typeCounts))
    },
    fetchEntryStatsByMonth() {
      this.entryStatsLoading = true
      getEntryStatsByMonth().then(response => {
        const data = (response && response.data) ? response.data : {}
        const { byPerson, bySource, typeColumns } = this.resolveEntryStatsData(data)
        this.entryStatsTypeColumns = typeColumns
        this.entryStatsTableData = this.buildEntryStatsRows(byPerson, typeColumns)
        this.entryStatsSourceTableData = this.buildEntryStatsRows(bySource, typeColumns)
      }).catch(() => {
        this.entryStatsTableData = []
        this.entryStatsSourceTableData = []
        this.entryStatsTypeColumns = []
      }).finally(() => {
        this.entryStatsLoading = false
      })
    },
    fetchEntryStatsByLastMonthPeriod() {
      this.entryStatsLastMonthLoading = true
      getEntryStatsByLastMonthPeriod().then(response => {
        const data = (response && response.data) ? response.data : {}
        const { byPerson, typeColumns } = this.resolveEntryStatsData(data)
        this.entryStatsLastMonthTypeColumns = typeColumns
        this.entryStatsLastMonthTableData = this.buildEntryStatsRows(byPerson, typeColumns)
      }).catch(() => {
        this.entryStatsLastMonthTableData = []
        this.entryStatsLastMonthTypeColumns = []
      }).finally(() => {
        this.entryStatsLastMonthLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

.entry-stats-row {
  margin-bottom: 32px;
}

::v-deep .entry-stats-total-row {
  font-weight: bold;
  background-color: #f5f7fa;
}

@media (max-width:1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
